import { makeStyles } from '@material-ui/core'

export const useAccidentAtlasTileGridStyles = makeStyles((theme) => ({
  tilesGrid: {
    display: 'grid',
    alignItems: 'start',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),
    padding: theme.spacing(8, 0, 8),
  },
  tilesRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(54, 0, 12),
  },
  tilesRow: {
    display: 'grid',
    alignItems: 'start',
    gap: theme.spacing(3),
    gridTemplateColumns: 'repeat(var(--tile-columns), 1fr)',
  },
}))
